module.exports = __webpack_public_path__ + "static/media/bell-g.ff057b9e.svg";